$(function() {
    // $('[data-ping]').each(function () {
    //     var url = this.dataset.ping;
    //     var status = document.querySelector('meta[name=status]').content;
    //     var interval = document.querySelector('meta[name=ping-interval]').content;

    //     setInterval(function() {
    //         ping(url, status);
    //     }, interval);
    //     setInterval(function() {
    //         ping(url, status);
    //     }, 20 * 1000);
    // });
    // function ping(url, status) {
    //     var opts = {
    //         status: status,
    //     }
    //     fetch(url, {
    //         method: 'post',
    //         headers: {
    //             'Accept': 'application/json',
    //             'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify(opts)
    //     })
    //     .then(function(response) {
    //         return response.json();
    //     })
    //     .then(function(data) {
    //         // console.log(data);
    //     })
    // }
});

